// extracted by mini-css-extract-plugin
module.exports = {"varNeutralBlack":"var(--tkww-union-color-neutral-black, #000)","tabsContainer":"tabsContainer--9d277","tab":"tab--826b4","active":"active--1cc49"};